export default [
  {
    path: 'teacher/:teacherId',
    redirect: 'teacher/:teacherId/home',
    component: () => import(/* webpackChunkName: "teacher" */ '@/views/Teacher'),
    meta: {
      keepAlive: false
    },
    children: [
      {
        name: 'teacher-home',
        path: 'home',
        component: () => import(/* webpackChunkName: "teacher-home" */ '@/views/Teacher/Home'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: '',
        component: () => import(/* webpackChunkName: "teacher-layout" */ '@/views/Teacher/Layout'),
        meta: {
          keepAlive: false
        },
        children: [
          {
            name: 'teacher-courses',
            path: 'courses',
            component: () => import(/* webpackChunkName: "teacher-courses" */ '@/views/Teacher/Courses'),
            meta: {
              keepAlive: true
            }
          },
          {
            name: 'teacher-videos',
            path: 'videos',
            component: () => import(/* webpackChunkName: "teacher-video" */ '@/views/Teacher/Videos'),
            meta: {
              keepAlive: true
            }
          },
          {
            name: 'teacher-creations',
            path: 'creations',
            component: () => import(/* webpackChunkName: "teacher-creation" */ '@/views/Teacher/Creations'),
            meta: {
              keepAlive: true
            }
          }
        ]
      }
    ]
  }
]
